<div class="updates-wrapper">
  <div class="updates-header">
    <span class="header-title" data-at-improvement-version
      >{{ '+UPDATES.VERSION.TITLE' | translate }} {{ update?.version }}</span
    >
    <span class="updates-date" data-at-improvement-date>{{ update?.date | date }}</span>
  </div>
  <div class="updates-content">
    <div *ngIf="update?.special">
      <span class="special-content" data-at-update-special-content>{{
        update.special | translate
      }}</span>
    </div>
    <div *ngIf="update?.improvements" [class.improvement-divider]="update?.fixes">
      <span data-at-fixes-title class="improvements-title">{{
        '+UPDATES.IMPROVEMENTS.TITLE' | translate
      }}</span>
      <section data-at-improvement-section class="section" *ngFor="let improvement of improvements">
        <ul>
          <li class="improvements-entry" data-at-improvement-section-title>
            {{ improvement.title }}
          </li>
        </ul>
        <span
          *ngIf="!!improvement.description"
          class="improvements-entry-description"
          data-at-improvement-section-description
        >
          {{ improvement.description }}
        </span>
        <span
          *ngIf="!!improvement.mediaUrl"
          class="improvements-entry-media"
          data-at-improvement-section-media
        >
          <ng-container
            *ngIf="isImage(improvement.mediaUrl); then imagePanel; else videoPanel"
          ></ng-container>

          <ng-template #imagePanel>
            <div class="improvements-image-wrapper" (click)="showMediaModal(improvement)">
              <img src="{{ improvement.mediaUrl }}" />
            </div>
          </ng-template>

          <ng-template #videoPanel>
            <div class="improvements-video-wrapper" (click)="showMediaModal(improvement)">
              <video>
                <source src="{{ improvement.mediaUrl }}" type="video/mp4" />
              </video>
            </div>
          </ng-template>
        </span>
      </section>
    </div>
    <div class="fixes-wrapper" *ngIf="update?.fixes">
      <span data-at-fixes-title class="fixes-title">{{ '+UPDATES.FIXES.TITLE' | translate }}</span>
      <ul data-at-fixes-description-list>
        <li class="fixes-entry" *ngFor="let fix of fixes">
          {{ fix }}
        </li>
      </ul>
    </div>
  </div>
</div>
